export const _state = {
    isGetPostsFetch: false,
    isCreatePostFetch: false,
    isUpdatePostFetch: false,
    errors: {},
    posts: [],
    post: {},
};

export function postsReducer(state = _state, action) {

    switch (action.type) {

        case 'API_GET_POSTS_CLOSE_FETCH':
            return {
                ...state,
                isGetPostsFetch: false,
            };

        case 'API_CREATE_POST_CLOSE_FETCH':
            return {
                ...state,
                isCreatePostFetch: false,
            };

        case 'API_UPDATE_POST_CLOSE_FETCH':
            return {
                ...state,
                isUpdatePostFetch: false,
            };

        case 'API_GET_POSTS':
            return {
                ...state,
                isGetPostsFetch: true,
            };

        case 'API_GET_POSTS_SUCCESS':
            return {
                ...state,
                posts: action.payload.data,
            };

        case 'API_GET_POSTS_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'API_CREATE_POST':
            return {
                ...state,
                isCreatePostFetch: true,
            };

        case 'API_CREATE_POST_SUCCESS':
            return {
                ...state,
                errors: {},
                post: action.payload.data,
            };

        case 'API_CREATE_POST_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'API_UPDATE_POST':
            return {
                ...state,
                isUpdatePostFetch: true,
            };

        case 'API_UPDATE_POST_SUCCESS':
            return {
                ...state,
                errors: {},
                post: action.payload.data,
            };

        case 'API_UPDATE_POST_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'ADD_POST':
            state.posts.push(action.payload.post);
            return {
                ...state,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/posts.js